'use strict';

var moment = require('moment');

const DATETIMEFORMAT = 'DD/MM/YYYY - HH:mm';
const DATEFORMAT = 'DD/MM/YYYY';

const IMAGE = {
    contentType: [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/tiff',
        'image/tiff',
        'image/bmp',
        'image/webp',
        'image/svg+xml',
    ],
    type: 'IMAGE',
};
const AUDIO = {
    contentType: ['audio/mpeg', 'audio/wav', 'audio/webm', 'audio/ogg', 'audio/aac', 'audio/midi'],
};
const VIDEO = {
    contentType: ['video/mp4', 'video/mpeg', 'video/ogg', 'video/webm', 'video/3gpp', 'video/quicktime', 'video/3gpp2'],
};
const PDF = {
    contentType: ['application/pdf'],
};
const WORD = {
    contentType: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
};
const PPT = {
    contentType: [
        'application/vnd.ms-powerpoint',
        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ],
};
const EXCEL = {
    contentType: ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
};

function iconByFiletype(type) {
    // pdf
    if (PDF.contentType.includes(type)) return ['far', 'file-pdf'];
    // image
    if (IMAGE.contentType.includes(type)) return ['far', 'file-image'];
    // word
    if (WORD.contentType.includes(type)) return ['far', 'file-word'];
    // excel
    if (EXCEL.contentType.includes(type)) return ['far', 'file-excel'];
    //powerpoint
    if (PPT.contentType.includes(type)) return ['far', 'file-powerpoint'];
    //audio
    if (AUDIO.contentType.includes(type)) return ['far', 'file-audio'];
    //video
    if (VIDEO.contentType.includes(type)) return ['far', 'file-video'];

    return ['far', 'file'];
}

function processFile(file) {
    var promise;
    if (IMAGE.contentType.includes(file.type)) {
        promise = new Promise((resolve, reject) => {
            const fReader = new FileReader();
            fReader.onload = () => {
                var newFile = {
                    file: file,
                    name: file.name,
                    src: fReader.result,
                    type: file.type,
                    size: file.size,
                    rendered: true,
                    properties: {},
                };
                resolve(newFile);
            };
            fReader.readAsDataURL(file);
        });
    } else {
        promise = new Promise((resolve, reject) => {
            resolve({
                file: file,
                name: file.name,
                type: file.type,
                size: file.size,
                rendered: false,
                properties: {},
            });
        });
    }
    return promise;
}

function formatDate(date, type = 'date', options) {
    if (options) {
        if (options.formatTZ) {
            return moment(date).tz('Europe/Sofia').format(DATEFORMAT);
        } else {
            return moment(date).tz('Europe/Sofia').format();
        }
    } else {
        if (date) {
            if (type == 'datetime') {
                return moment(date).format(DATETIMEFORMAT);
            }

            return moment(date).format(DATEFORMAT);
        }
    }
}
function formatDateTime(date) {
    if (date) {
        var convertedDate = moment.utc(date).toDate();
        return moment(convertedDate).format(DATETIMEFORMAT);
    }
}

function joinDateTime(startDate, endDate, hideDay) {
    const d1 = new Date(startDate);
    const d2 = new Date(endDate);
    // Check if the dates are on the same day
    const isSameDay =
        d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();

    // Format date as DD/MM/YYYY
    const formattedDate = formatDate(d1); //.toLocaleDateString('en-GB'); // UK format: DD/MM/YYYY

    // Format times as HH:mm (24-hour format)
    const startTime = d1.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });
    const endTime = d2.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    });

    // Return formatted string
    return isSameDay
        ? `${hideDay ? '' : formattedDate + ' - '}${startTime} -> ${endTime}`
        : `${formattedDate} ${startTime} -> ${d2.toLocaleDateString()} ${endTime}`;
}

function acronym(sentence) {
    return sentence
        .match(/\b(\w)/g)
        .slice(0, 3)
        .join('')
        .toUpperCase();
}

function currencyFormat(value, currency, intFormat) {
    if (intFormat && currency) {
        return new Intl.NumberFormat(intFormat, {
            style: 'currency',
            currency: currency,
        }).format(value);
    }
    if (currency) {
        return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: currency,
        }).format(value);
    }
    if (intFormat) {
        return new Intl.NumberFormat(intFormat).format(value);
    }

    return new Intl.NumberFormat().format(value);
}

function importModules({ files, nameRegex, excludeFolderName }) {
    var modules = {};

    files.keys().forEach((filename) => {
        // create the module name from fileName
        // remove the store.js extension and capitalize
        const moduleName = filename.replace(nameRegex, '').replace(/^\w/, (c) => c.toUpperCase());
        var split = moduleName.split('/');
        var folderName = '';
        if (split.length >= 1) {
            folderName = split[0];
        }
        folderName = folderName.toUpperCase();
        var name = moduleName.match(/([^\/]*)\/*$/)[1];
        var store = files(filename).default || files(filename);

        //if the object doesn't exist
        if (!excludeFolderName) {
            if (!modules[folderName]) {
                modules[folderName] = {};
            }
            modules[folderName][name] = store;
        } else {
            modules[name.toUpperCase()] = store;
        }
    });

    return modules;
}
function toFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}

function debounce(fn, delay) {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
}

function convertArrayToObject(array, key) {
    if (!array || !key) {
        return null;
    }
    const initialValue = {};
    return array.reduce((obj, item) => {
        return {
            ...obj,
            [item[key]]: item,
        };
    }, initialValue);
}

function getBrowserLocale(options = {}) {
    const defaultOptions = { countryCodeOnly: false };

    const opt = { ...defaultOptions, ...options };

    const navigatorLocale = navigator.languages !== undefined ? navigator.languages[0] : navigator.language;

    if (!navigatorLocale) {
        return undefined;
    }

    const trimmedLocale = opt.countryCodeOnly ? navigatorLocale.trim().split(/-|_/)[0] : navigatorLocale.trim();

    return trimmedLocale;
}

function delay(ms) {
    return new Promise((res) => setTimeout(res, ms));
}

function formatSeconds(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours >= 10 ? hours : '0' + hours}:${minutes >= 10 ? minutes : '0' + minutes}:${
        remainingSeconds >= 10 ? remainingSeconds : '0' + remainingSeconds
    }`;
}

function formatHoursAndMinutes(num) {
    if (num == 0) {
        return '-';
    }
    var hours = parseInt(num);
    var min = Math.round((num - hours) * 60);
    if (min == 0) {
        min = '00';
    }
    let strHours = hours > 0 ? `${hours}h ` : '';
    let strMin = min > 0 ? `${min}m ` : '';
    return strHours + strMin;
}

function formatDecimal(num, decimals = 2) {
    return (Math.round(num * 100) / 100).toFixed(decimals);
}

const getNumberLocale = function (value, decimals) {
    decimals = typeof decimals === 'number' ? decimals : 2;
    return Number.parseFloat(value).toLocaleString('fr-FR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
};

const setNumberLocale = function (value) {
    if (value) {
        value = String(value);
        return value.replace(',', '.').replace(' ', '');
    }
    return value;
};

function isEmptyObject(obj) {
    return Object.getPrototypeOf(obj) === Object.prototype && Object.keys(obj).length === 0;
}

function constructStoreQuery(params) {
    let query = '';
    if (Object.keys(params).length != 0) {
        query += '?';
        query += Object.entries(params)
            .map(([key, val]) => {
                if (Array.isArray(params[key])) {
                    return params[key].map((value) => `${key}=${value.toUpperCase()}`).join('&');
                } else if (key == 'sort') {
                    return `sort=${params[key].field},${params[key].order}`;
                } else {
                    return `${key}=${val}`;
                }
            })
            .join('&');
    }
    return query;
}

function stringToHslColor({ s = 75, l = 65, a = 1, str }) {
    //s = saturation
    //l = lightness
    if (str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 2) - hash);
        }

        var h = hash % 360;
        return `hsl(${h} ${s} ${l} / ${a})`;
        return 'hsl(' + h + ', ' + s + '%, ' + l + '% / 0)';
    }
    return '';
}

export default class Helpers {
    static acronym(sentence) {
        return sentence
            .match(/\b(\w)/g)
            .slice(0, 3)
            .join('')
            .toUpperCase();
    }
}

const isValid_IBANNumber = function (input) {
    const mod97 = (string) => {
        var checksum = string.slice(0, 2),
            fragment;
        for (var offset = 2; offset < string.length; offset += 7) {
            fragment = String(checksum) + string.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    };

    var CODE_LENGTHS = {
        AD: 24,
        AE: 23,
        AT: 20,
        AZ: 28,
        BA: 20,
        BE: 16,
        BG: 22,
        BH: 22,
        BR: 29,
        CH: 21,
        CR: 21,
        CY: 28,
        CZ: 24,
        DE: 22,
        DK: 18,
        DO: 28,
        EE: 20,
        ES: 24,
        FI: 18,
        FO: 18,
        FR: 27,
        GB: 22,
        GI: 23,
        GL: 18,
        GR: 27,
        GT: 28,
        HR: 21,
        HU: 28,
        IE: 22,
        IL: 23,
        IS: 26,
        IT: 27,
        JO: 30,
        KW: 30,
        KZ: 20,
        LB: 28,
        LI: 21,
        LT: 20,
        LU: 20,
        LV: 21,
        MC: 27,
        MD: 24,
        ME: 22,
        MK: 19,
        MR: 27,
        MT: 31,
        MU: 30,
        NL: 18,
        NO: 15,
        PK: 24,
        PL: 28,
        PS: 29,
        PT: 25,
        QA: 29,
        RO: 24,
        RS: 22,
        SA: 24,
        SE: 24,
        SI: 19,
        SK: 24,
        SM: 27,
        TN: 24,
        TR: 26,
    };
    var iban = String(input)
            .toUpperCase()
            .replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
        code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
        digits;
    // check syntax and length
    if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
        return false;
    }
    // rearrange country code and check digits, and convert chars to ints
    digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
        return letter.charCodeAt(0) - 55;
    });

    // final check
    if (mod97(digits) == 1) {
        return true;
    } else {
        return false;
    }
};

function stripHtmlTags(str) {
    // Regular expression to match HTML tags
    const regex = /<\/?[^>]+(>|$)/g;
    // Replace HTML tags with an empty string
    return str.replace(regex, '');
}
function parseLocaleNumber(input) {
    if (typeof input !== 'string') return NaN;

    const hasComma = input.includes(',');
    const hasDot = input.includes('.');

    // Beide aanwezig: beslis welke de decimalen zijn
    if (hasComma && hasDot) {
        const lastComma = input.lastIndexOf(',');
        const lastDot = input.lastIndexOf('.');
        if (lastComma > lastDot) {
            // Waarschijnlijk EU-stijl: "1.234,56"
            input = input.replace(/\./g, '').replace(',', '.');
        } else {
            // Waarschijnlijk US-stijl: "1,234.56"
            input = input.replace(/,/g, '');
        }
    } else if (hasComma && !hasDot) {
        // Alleen komma = EU decimaal
        input = input.replace(',', '.');
    } else if (hasDot && !hasComma) {
        // Alleen punt = US decimaal → geen aanpassing nodig
    }

    return Number(input);
}

export {
    formatDate,
    formatDateTime,
    acronym,
    currencyFormat,
    importModules,
    debounce,
    DATETIMEFORMAT,
    DATEFORMAT,
    IMAGE,
    AUDIO,
    VIDEO,
    PDF,
    WORD,
    EXCEL,
    PPT,
    iconByFiletype,
    processFile,
    convertArrayToObject,
    toFirstLetter,
    getBrowserLocale,
    formatHoursAndMinutes,
    formatSeconds,
    joinDateTime,
    delay,
    isEmptyObject,
    formatDecimal,
    constructStoreQuery,
    getNumberLocale,
    setNumberLocale,
    stringToHslColor,
    isValid_IBANNumber,
    stripHtmlTags,
    parseLocaleNumber,
};
